import React, { useEffect, useState } from "react";
import { Button, Dropdown, Menu, Row, Col, Spin, message } from "antd";
// import Icon from '@ant-design/icons';
import { LoadingOutlined } from "@ant-design/icons";

import moment from "moment";
import liracrypt from "../../components/Liracrypt/liracrypt";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import SessionError from "../../components/ApiErrorComp/SessionError";
// import { useDispatch, useSelector } from "react-redux";
// import { Drawer, Layout, Col, Row } from "antd";

const style = { padding: "8px 0", textAlign: "center" };

const colorList = [
  "#ff9ff3",
  "#feca57",
  "#ff6b6b",
  "#f368e0",
  "#ff9f43",
  "#ee5253",
  "#00d2d3",
  "#54a0ff",
  "#5f27cd",
];

const HotLine = ({selectedLid}) => {
  const [loginError, setLoginError] = useState(false);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const fetchHotlineData = () => {
    setLoading(true);
    liracrypt
      .get("/linedash/tabs/hotline", {})
      .then(({ data }) => {
        const fetchdata = data.data ? data.data : [];
        setData(fetchdata);
        setLoading(false);
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        setLoading(false);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const displayMessage = (val, id) => {
    setLoading(true);
    let postData = {
      _id: id,
      val,
      lid: selectedLid
    };
    liracrypt.post('/hotline/msg', postData).then(res => {
      
      message.success(res.data.message);
      setLoading(false);
    }).catch(err => {
      console.log("Error****:");
      setLoading(false);
      if (err.response !== undefined) {
        if (err.response.status !== 401) {
          ApiErrorComp(err.response.status);
        } else {
          setLoginError(true);
        }
      }
    })
    // setTimeout(() => {
    //   message.success("Message sent sucessfully");
    //   setLoading(false);
    // }, (Math.floor(Math.random() * 2) + 1) * 1000);
  };
  const getMenu = (val, index, id) => {
    return (
      <>
        <SessionError visible={loginError} />
        <Menu theme="dark">
          {val.map((value) => (
            <Menu.Item key={value}>
              <Button
                style={{
                  marginBottom: "0",
                  backgroundColor: colorList[index],
                  width: "100%",
                  color: "#fff",
                  fontWeight: "600",
                  borderRadius: "5px",
                  border: "0",
                }}
                onClick={() => displayMessage(value, id)}
              >
                {value}
              </Button>
            </Menu.Item>
          ))}
        </Menu>
      </>
    );
  };

  useEffect(() => {
    if (data === null && loading === false) {
      fetchHotlineData();
    }
  }, [data]);
  return !loading && data ? (
    <Row gutter={[8, 8]}>
      {data.map((rec, index) => (
        <Col className="gutter-row" span={8} key={index}>
          <div style={style}>
            <Dropdown overlay={getMenu(rec.val, index, rec._id)} trigger={["click"]}>
              <Button
                style={{
                  marginBottom: "0",
                  padding: "15px",
                  width: "180px",
                  fontSize: "18px",
                  backgroundColor: colorList[index],
                  height: "auto",
                  color: "#fff",
                  fontWeight: 600,
                  border: 0,
                  boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                  borderRadius: "7px",
                }}
              >
                {rec._id}
              </Button>
            </Dropdown>
          </div>
        </Col>
      ))}
    </Row>
  ) : (
    <div className="Loading">
      <Spin indicator={antIcon} />
    </div>
  );
};

export default HotLine;
